module.exports = __webpack_public_path__ + "img/6.2ee827a0.png";